import React from "react";
import ReactDOM from "react-dom";
import App from "./App";

const el = document.getElementById("giftcard-form-container");
if (el) {
  // add stripe javascript element
  const stripeScriptElement = document.createElement("script");
  stripeScriptElement.setAttribute("src", "https://js.stripe.com/v3/");
  document.head.appendChild(stripeScriptElement);

  // eslint-disable-next-line
  stripeScriptElement.addEventListener("load", () => ReactDOM.render(<App stripePublicKey={el.dataset.stripePublicKey} />, el),);
}
